class User 
{
    id: number;
    role: number;
    typeREF?: number;    
    uId: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    token?: string;
    sessionId?: string;
    mustChangePassword?: boolean;
            
    public static isSuper
    (
        type
    ) : boolean
    {
        let superUser: boolean;
        
        if (type == 0)
        {
            superUser = true;
        }
        else
        {
            superUser = false;    
        }
        
        return superUser;    
    }
    
}

export { User };
